import {
    BACK_DESTINATION_QUERY_STRING_PARAMETER,
    backLinkDestinations,
    filters,
    TOPIC_ID_DESTINATION_QUERY_STRING_PARAMETER
} from "../constants";
import config from "../config";

export function addBackDestinationParam(destinationUrl, extraParams, filterPersonId = undefined) {

    const url = new URL(location.origin + destinationUrl);
    const plansRegex = /plans\/(?:courses|public)\/\w+\/(current|past|withoutdate|all)\//i;
    const tableViewRegex = /plans\/courses\/(\d+)\/tableView/;
    const tableViewRegexMatch = location.pathname.match(tableViewRegex);
    const plansRegexMatch = location.pathname.match(plansRegex);
    const topicRegex = /\/plans\/(?:courses|public)\/\w+\/topics\/(\d+)/i;
    const topicRegexMatch = location.href.match(topicRegex);
    const topicsRegex = /\/plans\/(?:courses|public)\/\w+\/topics(?:[/]|[?]).*$/i;
    const topicsRegexMatch = location.href.match(topicsRegex);
    const parentDashboardRegex = /.+LocationId=(\d+).+&SummaryDashboardType=Parent/i;
    const dashboardUrl = "/Dashboard/Dashboard.aspx";
    const fromAdminDashboardRegex = /.*FromAdmin=True.*&LocationId=(\d+).*&LocationType=Hierarchy.*&SummaryDashboardType=Parent.*$/i;
    const courseOverviewRegexMatch = location.pathname.match(/(?!.*\/public\/).*Course\/course\.aspx/i);

    if (plansRegexMatch) {
        switch (plansRegexMatch[1]) {
            case "current":
                url.searchParams.append("BackDestination", backLinkDestinations.current);
                break;
            case "past":
                url.searchParams.append("BackDestination", backLinkDestinations.past);
                break;
            case "withoutdate":
                url.searchParams.append("BackDestination", backLinkDestinations.withoutDate);
                break;
            case "all":
                url.searchParams.append("BackDestination", backLinkDestinations.all);
                break;
            default:
                url.searchParams.append("BackDestination", backLinkDestinations.current);
                break;
        }
    } else if (topicRegexMatch) {
        url.searchParams.append("BackDestination", backLinkDestinations.topic);

        if (!url.searchParams.get("TopicId")) {
            url.searchParams.append("TopicId", topicRegexMatch[1]);
        }
    } else if (topicsRegexMatch) {
        url.searchParams.append("BackDestination", backLinkDestinations.topics);
    } else if (tableViewRegexMatch) {
        url.searchParams.append("BackDestination", backLinkDestinations.tableView);

        if (extraParams) {
            url.searchParams.append("BackData", JSON.stringify(extraParams));
        }
    } else if (courseOverviewRegexMatch) {
        url.searchParams.append("BackDestination", backLinkDestinations.overview);
    } else if (location.pathname.includes(config.calendarUrl)) {
        url.searchParams.append("BackDestination", backLinkDestinations.calendar);
        url.searchParams.append("BackData", JSON.stringify(extraParams));
    } else if (
        location.pathname.includes(config.dashboardUrl ? config.dashboardUrl : dashboardUrl)
    ) {
        const fromAdminDashboardRegexMatch = location.href.match(fromAdminDashboardRegex);
        const parentDashboardRegexMatch = location.href.match(parentDashboardRegex);

        if (fromAdminDashboardRegexMatch) {
            url.searchParams.append("BackDestination", backLinkDestinations.parentDashboard);
            url.searchParams.append(
                "BackData",
                JSON.stringify({ FromAdmin: "True", HierarchyId: fromAdminDashboardRegexMatch[1] })
            );
        }
        else if (parentDashboardRegexMatch) {
            url.searchParams.append("BackDestination", backLinkDestinations.parentDashboard);
            url.searchParams.append(
                "BackData",
                JSON.stringify({ HierarchyId: parentDashboardRegexMatch[1] })
            );
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const childIdFromQueryParameter = urlParams.get("ChildId");

            if (childIdFromQueryParameter && childIdFromQueryParameter > 0) {
                url.searchParams.append("ChildId", childIdFromQueryParameter);
            }
        } else {
            url.searchParams.append("BackDestination", backLinkDestinations.myPage);
        }
    } else if (location.pathname.includes("tableView")) {
        url.searchParams.append("BackDestination", backLinkDestinations.tableView);
    } else if (location.pathname.includes("CalendarPlans")) {
        url.searchParams.append("BackDestination", backLinkDestinations.calendarPlans);
        if(filterPersonId) {
            url.searchParams.append("FilterPersonId", filterPersonId);
        }
    } else {
        url.searchParams.set("BackDestination", backLinkDestinations.current);

        if (extraParams) {
            url.searchParams.append("BackData", JSON.stringify(extraParams));
        }
    }

    if (!url.searchParams.get("ChildId") && config.childId > 0) {
        url.searchParams.append("ChildId", config.childId);
    }

    return url.href;
};

export const addBackDestinationAndTopicIdParamsFromCurrentUrl = (destinationUrl) =>
    transferParam(
        location.href,
        transferParam(
            location.href,
            destinationUrl, 
            BACK_DESTINATION_QUERY_STRING_PARAMETER
        ),
        TOPIC_ID_DESTINATION_QUERY_STRING_PARAMETER
    );

const transferParam = (sourceUrl, destinationUrl, param) => 
    hasParam(sourceUrl, param)
        ? setParam(destinationUrl, param, getParam(sourceUrl, param))
        : destinationUrl;

export const getAllQueryStringParametersFromCurrentUrl = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    if (urlSearchParams.size > 0) {
        const queryStringParameters = {};

        for (const [parameterKey, parameterValue] of urlSearchParams) {
            queryStringParameters[parameterKey] = parameterValue;
        }

        return queryStringParameters;
    }

    return null;
};

export const getAllQueryStringParametersFromCurrentUrlWithTopicsAndPagination = (topicFilterIds, pageIndex, pageSize, topicFilterManuallyChanged) => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    if (urlSearchParams.size > 0) {
        const queryStringParameters = {};

        for (const [parameterKey, parameterValue] of urlSearchParams) {
            queryStringParameters[parameterKey] = parameterValue;
        }

        // Add to url parameters the details to help navigation with the filters
        queryStringParameters[filters.topicFilterManuallyChanged] = topicFilterManuallyChanged;
        queryStringParameters[filters.topicIds] = topicFilterIds.join(",");
        queryStringParameters[filters.pageIndex] = pageIndex;
        queryStringParameters[filters.pageSize] = pageSize;

        return queryStringParameters;
    }

    return null;
};

export const getDestinationUrlWithExtraParametersFromCurrentUrl = (
    destinationUrl,
    queryStringParameters = null
) => {
    if (!destinationUrl) {
        return;
    }

    const urlSearchParams = new URLSearchParams(window.location.search);

    const url = new URL(location.origin + destinationUrl);

    const addQueryStringParameters = queryStringParameters => {
        if (!queryStringParameters) {
            return;
        }

        for (const [parameterKey, parameterValue] of Object.entries(queryStringParameters)) {
            url.searchParams.set(parameterKey, parameterValue);
        }
    };

    const backdataQueryStringParameter = urlSearchParams.get("BackData");

    if (backdataQueryStringParameter) {
        addQueryStringParameters(JSON.parse(backdataQueryStringParameter));
    }

    addQueryStringParameters(queryStringParameters);

    return url.href;
};

export const hasParam = (destinationUrl, param) => {
    const urlSegments = destinationUrl.split('?');
    const urlSearchParams = new URLSearchParams(urlSegments[1]);

    return urlSearchParams.has(param);
};

export const removeParam = (destinationUrl, param) => {
    const urlSegments = destinationUrl.split('?');
    const urlSearchParams = new URLSearchParams(urlSegments[1]);

    urlSearchParams.delete(param);

    return urlSegments[0]+'?'+decodeURIComponent(urlSearchParams.toString());
};

export const setParam = (destinationUrl, param, value) => {
    const urlSegments = destinationUrl.split('?');
    const urlSearchParams = new URLSearchParams(urlSegments[1]);

    urlSearchParams.set(param, value);

    return urlSegments[0]+'?'+decodeURIComponent(urlSearchParams.toString());
};

export const getParam = (destinationUrl, param) => {
    const url = new URL(location.origin + destinationUrl);
    const urlSearchParams = new URLSearchParams(url.search);

    const value = urlSearchParams.get(param);

    return value;
};

export const addParams = (destinationUrl, params) => {
    if (!destinationUrl) {
        return;
    }

    const url = new URL(destinationUrl);

    if (params) {
        for (const [key, val] of Object.entries(params)) {
            url.searchParams.set(key, val);
        }
    }
    
    return url.href;
};